import { RejectType } from '@uirouter/angularjs'

export function routerRun ($log, $transitions) {
  'ngInject'

  // Print error and stack on state change error
  $transitions.onError({}, transition => {
    const error = transition.error()

    // IGNORED and SUPERSEDED are normal routing events, not real errors
    if (error.type === RejectType.IGNORED) {
      $log.info(`[Router Run] ${error.message} - The transition is targeting the same state`)
      return
    }
    if (error.type === RejectType.SUPERSEDED) {
      $log.info(`[Router Run] ${error.message}`)
      return
    }
    if (error.type === RejectType.ABORTED) {
      $log.info(`[Router Run] ${error.message}`)
      return
    }

    // Safely convert detail to a string so loggers (e.g. Loggly) don't try to
    // JSON.stringify complex uirouter objects with circular references.
    const detail = error.detail
    const detailStr = detail instanceof Error
      ? detail.toString()
      : String(detail || error.message)

    $log.error(`[Router Run] ${error.message}`, detailStr)
  })
}
